import React, { createContext, useContext, useEffect, useState } from "react";

const I18nContext = createContext(null);

const DICT = {
    es: {
        nav_home: "Inicio",
        nav_menu: "Menú",
        nav_story: "Historia",
        nav_gallery: "Galería",
        nav_contact: "Contacto",
        nav_admin: "Admin",
        cta_view_menu: "Ver el menú",
        cta_reserve: "Reservar mesa",
        cta_call: "Llamar",
        badge_hero: "Auténtico · Habanero · Familiar",
        hero_tagline: "Un pedacito de La Habana",
        menu_title: "Menú de la casa",
        menu_sub: "Recetas cubanas tradicionales, servidas con orgullo.",
        menu_featured: "Especial de la casa",
        story_kicker: "Nuestra Historia",
        story_since: "Desde el corazón de Cuba",
        gallery_title: "Momentos",
        gallery_sub: "Sabores, colores y el alma habanera.",
        contact_title: "Reserva tu mesa",
        contact_sub: "Escríbenos y te confirmamos en minutos.",
        form_name: "Nombre",
        form_email: "Correo electrónico",
        form_phone: "Teléfono",
        form_message: "Mensaje",
        form_send: "Enviar mensaje",
        form_thanks: "¡Gracias! Te contactaremos pronto.",
        hours_label: "Horario",
        phone_label: "Teléfono",
        address_label: "Dirección",
        footer_rights: "Todos los derechos reservados",
        made_with: "Hecho con amor cubano",
        admin_title: "Panel de administración",
        admin_login: "Iniciar sesión",
        admin_email: "Correo",
        admin_password: "Contraseña",
        admin_logout: "Cerrar sesión",
        admin_menu_tab: "Menú",
        admin_content_tab: "Contenido",
        admin_gallery_tab: "Galería",
        admin_categories_tab: "Categorías",
        admin_add: "Añadir",
        admin_save: "Guardar",
        admin_delete: "Eliminar",
        admin_cancel: "Cancelar",
        admin_edit: "Editar",
        loading: "Cargando...",
        menu_ornament: "La Carta",
        menu_categories_label: "Categorías",
        menu_footer_tag: "Buen provecho",
        menu_prices_note: "Precios en USD. Impuestos no incluidos.",
        menu_preview_title: "¡Salud!",
        menu_preview_hint: "Pasa el ratón sobre un plato",
        menu_preview_sub: "Hover to preview",
        menu_soon: "Próximamente",
        gallery_ornament: "Galería",
        contact_ornament: "Reserva",
        story_havana: "La Habana Vieja",
        story_quote: "El alma cubana",
    },
    en: {
        nav_home: "Home",
        nav_menu: "Menu",
        nav_story: "Story",
        nav_gallery: "Gallery",
        nav_contact: "Contact",
        nav_admin: "Admin",
        cta_view_menu: "View menu",
        cta_reserve: "Reserve table",
        cta_call: "Call",
        badge_hero: "Authentic · Havana · Family",
        hero_tagline: "A little piece of Havana",
        menu_title: "House Menu",
        menu_sub: "Traditional Cuban recipes, served with pride.",
        menu_featured: "House special",
        story_kicker: "Our Story",
        story_since: "From the heart of Cuba",
        gallery_title: "Moments",
        gallery_sub: "Flavors, colors and the soul of Havana.",
        contact_title: "Reserve your table",
        contact_sub: "Write to us — we confirm in minutes.",
        form_name: "Name",
        form_email: "Email",
        form_phone: "Phone",
        form_message: "Message",
        form_send: "Send message",
        form_thanks: "Thank you! We'll reach out soon.",
        hours_label: "Hours",
        phone_label: "Phone",
        address_label: "Address",
        footer_rights: "All rights reserved",
        made_with: "Made with Cuban love",
        admin_title: "Admin Panel",
        admin_login: "Sign in",
        admin_email: "Email",
        admin_password: "Password",
        admin_logout: "Sign out",
        admin_menu_tab: "Menu",
        admin_content_tab: "Content",
        admin_gallery_tab: "Gallery",
        admin_categories_tab: "Categories",
        admin_add: "Add",
        admin_save: "Save",
        admin_delete: "Delete",
        admin_cancel: "Cancel",
        admin_edit: "Edit",
        loading: "Loading...",
        menu_ornament: "The Menu",
        menu_categories_label: "Categories",
        menu_footer_tag: "Enjoy your meal",
        menu_prices_note: "Prices in USD. Taxes not included.",
        menu_preview_title: "Cheers!",
        menu_preview_hint: "Hover over a dish",
        menu_preview_sub: "Hover to preview",
        menu_soon: "Coming soon",
        gallery_ornament: "Gallery",
        contact_ornament: "Reservations",
        story_havana: "Old Havana",
        story_quote: "The Cuban soul",
    },
};

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("cbc_lang") || "es";
        } catch (_e) {
            return "es";
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem("cbc_lang", lang);
            document.documentElement.lang = lang;
        } catch (_e) {
            /* noop */
        }
    }, [lang]);

    const t = (key) => (DICT[lang] && DICT[lang][key]) || key;
    const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));
    const localized = (obj, base) =>
        obj?.[`${base}_${lang}`] ?? obj?.[`${base}_es`] ?? obj?.[base] ?? "";

    return (
        <I18nContext.Provider value={{ lang, setLang, toggle, t, localized }}>
            {children}
        </I18nContext.Provider>
    );
}

export function useI18n() {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
    return ctx;
}
